export default __webpack_public_path__ + "static/media/entry.da2b57f0.png";